import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  sideMenu: {
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    left: "0px",
    width: "7%",
    height: "100%",
    backgroundColor: "#000000",
  },
});

export const SideMenu = () => {
    const classes = useStyles()

  return <div className={classes.sideMenu}></div>;
};
